/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramUsersControllerPatchEmailMutationRequest,
  TelegramUsersControllerPatchEmailMutationResponse,
  TelegramUsersControllerPatchEmail400,
  TelegramUsersControllerPatchEmail401,
  TelegramUsersControllerPatchEmail429,
} from '../../types/TelegramUsersControllerPatchEmail.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramUsersPatchEmail } from '../../methods/telegramUsersPatchEmail.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramUsersPatchEmailMutationKey = () => [{ url: '/api/telegram/users/email' }] as const;

export type TelegramUsersPatchEmailMutationKey = ReturnType<typeof telegramUsersPatchEmailMutationKey>;

/**
 * {@link /api/telegram/users/email}
 */
export function useTelegramUsersPatchEmail<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramUsersControllerPatchEmailMutationResponse,
      ResponseErrorConfig<
        | TelegramUsersControllerPatchEmail400
        | TelegramUsersControllerPatchEmail401
        | TelegramUsersControllerPatchEmail429
      >,
      { data: TelegramUsersControllerPatchEmailMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramUsersControllerPatchEmailMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramUsersPatchEmailMutationKey();

  return useMutation<
    TelegramUsersControllerPatchEmailMutationResponse,
    ResponseErrorConfig<
      TelegramUsersControllerPatchEmail400 | TelegramUsersControllerPatchEmail401 | TelegramUsersControllerPatchEmail429
    >,
    { data: TelegramUsersControllerPatchEmailMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramUsersPatchEmail(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
